var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:2.835px}.cls-3{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Students",
    transform: "translate(-1017 -343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_811",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(1017 343)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    transform: "translate(853.12 32.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    d: "M288.611 350.426c-3.843 1.758-6.7 3.229-9.682 4.374-2.3.885-3.546 2.087-3.171 4.733.9 6.308 1.655 12.635 2.491 18.952.583 4.4.218 8.533-2.866 12.087a13.767 13.767 0 0 0-1.883 3.2c-2.789 5.919-6.331 11.238-11.894 14.924-6.047 4.008-12.569 4.132-18.4-.17a36.8 36.8 0 0 1-7.67-7.748 88.952 88.952 0 0 1-7.648-12.524c-1.9-3.757-1.794-7.572-.588-11.978 1.664-6.081 1.576-12.661 1.964-19.044.042-.684-1.645-1.673-2.694-2.188-2.99-1.467-6.065-2.763-9.107-4.127v-1.18c1.712-.9 3.377-1.9 5.143-2.675 8.214-3.6 16.357-7.395 24.741-10.549 2.837-1.067 6.688-1.463 9.416-.427 9.673 3.67 19.064 8.083 28.549 12.244a34.774 34.774 0 0 1 3.299 2.096z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    d: "M220.768 383.078c-.372-2.287-1.089-4.581-1.044-6.861.1-4.922.665-9.833.868-14.755.064-1.545-.534-3.107-.6-4.672a3.941 3.941 0 0 1 .769-2.251 1.613 1.613 0 0 1 1.566.024 2.961 2.961 0 0 1 .9 1.889c.044 5.436.039 10.874-.057 16.31-.06 3.423-.3 6.843-.46 10.265z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    d: "M303.7 436.613c-1.341-3.018-3.481-5.683-4.8-8.709-3.39-7.788-7.884-14.206-17.1-15.416a74.205 74.205 0 0 0-9.06-.793 4.756 4.756 0 0 0-3.176 1.682c-4.007 4.831-7.854 9.795-11.757 14.714l-1.6-.421v-12.585h-7.074v12.272l-1.7.347c-3.024-3.543-6.741-6.712-8.9-10.721-2.828-5.254-6.532-5.666-11.7-4.983-5.991.791-11.632 2.042-15.268 7.173-2.378 3.357-3.922 7.3-5.925 10.931-1.055 1.912-2.527 3.621-3.388 5.605-1.046 2.413-2.622 5.161-2.28 7.518 2.049 14.129 4.571 28.19 6.963 42.268.868 5.109 3.842 7.662 9.155 7.733 5.687.074 11.377-.016 17.066-.015 18.714.006 37.429.067 56.143 0 5.119-.017 7.966-2.662 8.815-7.613 2.411-14.077 4.939-28.135 7.123-42.247.321-2.131-.613-4.653-1.537-6.74zm-95.336-7.033c1.883-3.074 3.333-6.41 5.568-9.251 3.416-4.342 8.717-5.4 14.347-6.071 4.858-.578 5.067-.7 7.724 3.742 2.028 3.393 7.159 8 10 11 .533-.1 4.467.1 5 0v-12c2.09 0 1.848-.13 4-.13V429c.5.119 2.5.881 3 1 3.667-4.163 7.235-8.911 11-13a17.723 17.723 0 0 1 3-3c2.319-1.639 5.1.338 7.928.672 8.663 1.024 12.886 6.455 16.072 13.047 1.058 2.191 2.68 4.159 3.917 6.281h-94.556c.822-1.541 2.072-2.909 2.997-4.42zm94.371 15.169c-2.358 13.314-4.552 26.658-6.818 39.989-.763 4.484-2.548 6.2-7.083 6.207q-36.222.079-72.445 0c-4.726-.009-6.509-1.808-7.283-6.466q-3.382-20.377-6.868-40.74c-.894-5.266 1.236-7.918 6.64-7.935 14.54-.044 29.081-.015 43.621-.015h42.862c6.652.011 8.522 2.46 7.371 8.96z",
    className: "cls-3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    cx: 6.449,
    cy: 6.449,
    r: 6.449,
    className: "cls-3",
    transform: "translate(245.595 454.87)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    d: "M226.5 355.5l27 7 24-7",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    d: "M229.241 368.819s20.229-5.879 47.494.651",
    className: "cls-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.029ae7f2308e9f7662cd49449c89f56e.svg";
export { ForwardRef as ReactComponent };